import React, { useState, useEffect, useCallback } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import AlertModal from "web/components/AlertModal";
import { useHistory } from "react-router-dom";
import Spinner from "web/components/Spinner";
import Layout from "web/components/Layout";
import Breadcrumb from "web/components/Breadcrumb";
import PalletsSidebar from "web/components/PalletsSidebar";
import FilterIcon from "web/assets/images/filterIcon.png";

import Bids from "./Bids";
import styled from "styled-components";
import { fetchLanguageContentNew } from "redux/actions/language";
import FilterModal from "./FilterModal";
import InventoryFilterModal from "./InventoryFilterModal";

const MyBids = ({
  response,
  pageType,
  type,
  activePage,
  expanded,
  activeSearch,
  callBackFun,
}) => {
  const [pageActive, setPageActive] = useState("All");
  const [filterBidStatus, setFilterBidStatus] = useState("All");
  let toDate = new Date();
  let fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - 31);
  toDate.setDate(fromDate.getDate() + 31);
  const [requestedFromDate, setRequestedFromDate] = useState(
    fromDate.toISOString().substr(0, 10)
  );
  const [requestedToDate, setRequestedToDate] = useState(
    toDate.toISOString().substr(0, 10)
  );
  let history = useHistory();
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);

  const [filterPopUpModal, setFilterPopUpModal] = useState(false);
  const toggleFilterPopUpModal = () => setFilterPopUpModal(!filterPopUpModal);
  const [inventoryFilterPopUpModal, setInventoryFilterPopUpModal] =
    useState(false);
  const toggleInventoryFilterPopUpModal = () =>
    setInventoryFilterPopUpModal(!inventoryFilterPopUpModal);

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();

  const [dropDownArr, setDropDownArr] = useState([]);

  useEffect(() => {
    if (languageContentNew.MyBids_Page) setPageLanguageContents(languageContentNew.MyBids_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  useEffect(() => {
      setDropDownArr([
        {
          id: "0",
          label: pageLanguageContents?.Bids_Header[1]?.OldPost,
          value: "ASC",
        },
        {
          id: "1",
          label: pageLanguageContents?.Bids_Header[2]?.LatestPost,
          value: "DESC",
        },
      ]);
  }, [pageLanguageContents]);

  let title = "";

  let breadcrumbMapArr = [
    {
      name: pageLanguageContents?.Breadcrumb[0]?.Home,
      link: "/dashboard",
    },
  ];
  const [setTimer, setTimerState] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      setTimeout(() => {
        if (response?.bidList && response?.bidList?.length=== 0) {
          setTimerState(true);
        } else {
          setTimerState(false);
        }
      }, 1000);
    }
  });
  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );

  const allbids = (response) => {
    return (
      <>
        {response && response?.bidList && response?.bidList?.length !== 0 && <MainSection>
            {/* <MobileView
              response={response}
              requestType="Pickup"
              callBackFun={callBackFun}
              displayNameHeader={pageLanguageContents?.Bids_Header[4]?.Pickup}
            /> */}
            <div className="community-details-cards">
              <div class="community-details-header seller">
                <div class="community-name">
                  <h4>
                    Bids
                  </h4>
                </div>
              </div>
              <Bids
                response={response}
                requestType="Pickup"
                callBackFun={callBackFun}
              />
            </div>
          </MainSection>}

          {!response && <NoRecordFound>
            {pageLanguageContents?.Bids_Header[8]?.NoRecord}
          </NoRecordFound>}
      </>
    );
  };

  return (
    <Layout selectedSearch={"MyOfferBids"} topBarViewMobile={'hide'}>
      {loaderVisible && <Spinner />}

      <div className="breadcrumb-wrapper-mybids">
        <Breadcrumb
          breadcrumbArr={breadcrumbMapArr}
          selected={pageLanguageContents?.Breadcrumb[1]?.PalletNeeds}
          title=""
        />
        <img src={FilterIcon} alt="" onClick={toggleFilterPopUpModal} />       
      </div>

      <div className="custom-wrapper">
        <div className="pd-right-nav">
          {activePage && (
            <PalletsSidebar
              postType={type}
              activePage={activePage}
              expandedPallet={expanded}
              activeSearch={activeSearch}
            />
          )}
        </div>
        
        <div className="left-content">
          {allbids(response)}
        </div>
      </div>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />

      <FilterModal
        isOpen={filterPopUpModal}
        toggle={toggleFilterPopUpModal}
        callBack={toggleFilterPopUpModal}
        callBackFun={callBackFun}
      />
      <InventoryFilterModal
        isOpen={inventoryFilterPopUpModal}
        toggle={toggleInventoryFilterPopUpModal}
        callBack={toggleInventoryFilterPopUpModal}
        callBackFun={(value) => {
          setFilterBidStatus(value.filterByStatus);
          setPageActive(value.filterByDelivery);
          setRequestedFromDate(value.fromDate);
          setRequestedToDate(value.toDate);
        }}
      />
    </Layout>
  );
};

export default MyBids;

const NoRecordFound = styled.div`
  text-align: center;
  padding-top: 5%;
  padding-bottom: 5%;
  background: white;
`;

const MainSection = styled.div`
  margin-bottom: 35px;
  .community-details-cards {
    display: block;
  }
  > h6 {
    box-shadow: 0 0 20px 0 rgb(0 0 0 / 8%);
    padding: 7px 12px;
    background-color: #0a1f30;
    color: #fff;
    font-size: 18px;
    border-radius: 5px 5px 0 0;
  }
  @media (max-width: 560px) {
    .community-details-cards {
      /* display: none; */
    }
  }
`;